<template>
    <dx-load-panel
        id="global-app-load-panel"
        ref="globalLoadPanel"
        :hide-on-outside-click="false"
        :shading="true"
        :show-indicator="true"
        :show-pane="true"
        :visible="false"
        message="Загрузка..."
        shading-color="rgba(0,0,0,0.05)"
    />
    <ai-global-tooltip ref="globalTooltip"/>
    <div id="root">
        <component :is="$route.meta.layout">
            <div id="ai-app-current-layout" class="flex flex-col w-full h-full">
                <router-view />
            </div>
        </component>
    </div>
</template>

<script>
export default {
    name: 'App',
};
</script>

<script setup>
import { ref, onMounted } from 'vue';
import { DxLoadPanel } from 'devextreme-vue/load-panel';

import { setLoadPanelInstance } from '@/components/utils/ai-global-load-panel';
import { setTooltipInstance } from '@/components/utils/ai-gobal-tooltip';
import AiGlobalTooltip from '@/components/ai-global-tooltip.vue';

const globalLoadPanel = ref();
const globalTooltip = ref();

onMounted(() => {
    setLoadPanelInstance(globalLoadPanel.value.instance);
    setTooltipInstance(globalTooltip.value);
});
</script>

<style lang="scss">
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';

html,
body {
    margin: 0px;
    min-height: 100%;
    height: 100%;
}

#root {
    height: 100vh;
}

* {
    box-sizing: border-box;
}

.app {
    @import '@/themes/generated/variables.base.scss';
    background-color: darken($base-bg, 5);
    display: flex;
    height: 100%;
    width: 100%;
}

.dx-submenu {
    .dx-icon {
        width: 40px;
        height: 40px;
    }
}

.ai-def {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.ai-def-header {
    text-align: center;
    margin: 10px;
    font-size: 20px;
}

.ai-def-text {
    text-align: left;
    margin: 10px;
    font-size: 14px;
}

.ai-logo-full {
    padding: 0;
    cursor: pointer;
}

.ai-svg-color {
    fill: #286eb6;
}

.ai-svg-16 {
    fill: #286eb6;
    width: 16px;
    height: 16px;
}

#ai-app-current-layout {
    background-color: #fff;
}
</style>
